import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { RiArrowLeftCircleLine } from 'react-icons/ri'

import styles from './MainNav.module.css'

import '../../i18n'

function MainNav ({ NavBarLinks }) {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(true)

  const localStorageInfo = JSON.parse(localStorage.getItem('mainNav'))

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (localStorage.getItem('mainNav')) {
        handleOpen(localStorageInfo)
      }
    }
    return () => (mounted = false)
  }, [localStorageInfo])

  function handleOpen (isOpen) {
    localStorage.setItem('mainNav', JSON.stringify(isOpen))
    document.getElementById('mainContent').style.marginLeft = isOpen
      ? 'var(--MainNav-width)'
      : 'var(--MainNav-closed-width)'
    setIsOpen(isOpen)
  }

  return (
    <aside className={isOpen ? styles.mainNavContainer : styles.mainNavContainerClosed} data-testid='mainNav-aside'>
      <div className={styles.sidenavInnerScroll}>
        <ul className={styles.sidenavTopLevelItems}>
          <NavBarLinks
            navBarLinks={styles.navBarLinks}
            navBarLinkActive={styles.navBarLinkActive}
          />
          <span
            className={styles.toggleSidebarButton}
            onClick={() => {
              document.getElementById('mainContent').style.transition =
                'margin-left 0.3s ease-out'
              handleOpen(!isOpen)
            }}
            data-testid='mainNav-collapse-button'
          >
            <li className={styles.closeNavButton}>
              <RiArrowLeftCircleLine />
              <span>{t('mainNav.Collapse')}</span>
            </li>
          </span>
        </ul>
      </div>
    </aside>
  )
}

export default MainNav
